'use strict';

// Simple interceptor which redirects users to maintenance page when there
// are any issues
angular.module('mobile-apps')
	.config(['$provide', '$httpProvider', function ($provide, $httpProvider) {

		$provide.factory('ErrorInterceptor', ['$q', '$window', function ($q, $window) {
			return {
				responseError: function (rejection) {
					// If we get the status 503 it means that there is something
					// wrong with the backend like that the connection to Mongo
					// got lost. So redirect user to another page so that the
					// maintenance page gets displayed. Also redirect for 403
					// which means no access
					if (rejection.status === 403) {
						$window.location.href = '!/#/projects';

					// TODO: Activate again, currently temporary deactivated for AL-1711
					// } else if (rejection.status === 503) {
					// 	$window.location.href = '/!/#/projects';
					// 	// Here we also need a reload else it does not display the maintenance page
					// 	$window.location.reload();
					} else if (rejection.status === 402) {
						// Account is locked so redirect him to locked page
						var url = '/#!/account-locked/';

						if (rejection.data.type) {
							url += rejection.data.type + '/' + encodeURI(JSON.stringify(rejection.data.user));
						}

						$window.location.href = url;
					}

					return $q.reject(rejection);
				}
			};
		}]);

		// Add the interceptor to the $httpProvider
		$httpProvider.interceptors.push('ErrorInterceptor');
	}]);
